import { render } from "./AdminMessage.vue?vue&type=template&id=6a51ddbc&scoped=true"
import script from "./AdminMessage.vue?vue&type=script&lang=js"
export * from "./AdminMessage.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a51ddbc"]])

export default __exports__